// Who an address bills to (customers.setBillTo), in words: the line on the customer's Locations,
// and what Save says, naming a site contact cleared because they were the old bill-to's (F-54).

type Loc = { name: string | null; line1: string; billTo?: { name: string } | null };

export const placeName = (l: Loc): string => l.name ?? l.line1;

/** "Bills to Harbourview Strata", or "Bills to Okafor family (the customer)". */
export const billToLine = (l: Loc, customerName: string): string =>
  l.billTo ? `Bills to ${l.billTo.name}` : `Bills to ${customerName} (the customer)`;

/** What Save says: where the address bills now, and a site contact who went with the old bill-to. */
export function billToSaid(p: {
  place: string;
  customerName: string;
  to: string | null;
  was: string | null;
  cleared: { name: string } | null;
}): string {
  const now = p.to ? `${p.place} now bills to ${p.to}.` : `${p.place} bills ${p.customerName} again.`;
  if (!p.cleared) return now;
  return `${now} ${p.cleared.name} was its site contact as ${p.was ?? 'the old bill-to'}’s, so it has none now: its visit texts go to ${p.customerName}.`;
}

/** Said before Save when the site contact is the bill-to's and the bill-to is changing. */
export const clearsSiteContact = (siteName: string, was: string): string =>
  `${siteName} is the site contact as ${was}’s: changing the bill-to clears them, and the visit texts go to the customer.`;
